export const bootstrapThemeClasses = ['default', 'primary', 'success', 'info', 'warning', 'danger', 'link', 'premium'];
